<template>
  <p>TODO: Loader</p>
</template>

<script>
export default {
  name: 'Redirect',

  data() {
    return {
      error: '',
    };
  },

  mounted() {
    this.authenticate();
  },

  methods: {
    async authenticate() {
      const organisationId = parseInt(
        this.$route.query.organisationId || '0',
        undefined,
      );
      const tommId = parseInt(this.$route.query.userId || '0', undefined);
      const authentication = this.$route.query.auth;
      let response;

      try {
        response = await this.$http.post('/auth/redirect', {
          organisationId,
          authentication,
          tommId,
        });
      } catch (error) {
        this.error = error.response.data.message;

        return;
      }

      const { user, token } = response.data;
      this.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
      this.$store.commit('setUserData', user);
      this.$store.commit('setAuthToken', token);
      this.$router.push({ name: 'reporting' });
    },
  },
};
</script>
